import {Stack, Typography, SegmentedToggle, Icon} from '@mdsol/onex-design'
import React, {FC} from 'react'
import {legionFeatureFlagToggle} from '../../../redux/databases/databases.duck'
import {useAppDispatch} from '../../../redux/config'
import {FeatureFlagStatus, FeatureStatus} from 'graphql-api'

type props = {
  databaseId: string,
  name: string,
  status: FeatureStatus,
  disabled: boolean,
}

export const FeatureFlag: FC<props> = (props) => {
  const dispatch = useAppDispatch()
  const ENABLE_LABEL = FeatureStatus.Enable
  const PAUSE_LABEL = FeatureStatus.Pause
  const OFF_LABEL = FeatureStatus.Off

  const {databaseId, name, status, disabled} = props
  const id = `${name}-id`
  const label = name.replace(/^LegionEnable/i, '').replace(/([A-Z])/g, ' $1').trim()

  const handleToggle = (updatedStatus)=> {
    const featureFlagStatus = {
      name: name,
      status: updatedStatus,
    } as FeatureFlagStatus
    dispatch(legionFeatureFlagToggle(databaseId, featureFlagStatus))
  }

  return (
    <Stack
      direction='horizontal'
      className='switch-wrapper'
      role='feature-flag-segmented-toggle-component'>
      <Typography variant='label' >
        {label}
      </Typography>
      <SegmentedToggle
        className='feature-flag-segmented-toggle'
        groupName={id}
        variant='icons'
        items={[
          {
            id: id+'-'+ENABLE_LABEL,
            label: <Icon key={name+ENABLE_LABEL+'-key'}>play_arrow</Icon>,
            name: ENABLE_LABEL,
            value: ENABLE_LABEL,
            disabled: disabled,
          },
          {
            id: id+'-'+PAUSE_LABEL,
            label: <Icon key={name+PAUSE_LABEL+'-key'}>pause</Icon>,
            name: PAUSE_LABEL,
            value: PAUSE_LABEL,
            disabled: disabled,
          },
          {
            id: id+'-'+OFF_LABEL,
            label:<Icon key={name+OFF_LABEL+'-key'}>stop</Icon>,
            name: OFF_LABEL,
            value: OFF_LABEL,
            disabled: disabled,
          },
        ]}
        onChange={handleToggle}
        size='sm'
        id={id}
        dataTestId={id}
        value={status}
      />
    </Stack>
  )
}
